import PropTypes from 'prop-types'
import clsx from 'clsx'
import Typo from 'constants/typography'
import styles from './styles.scss'

/**
 *
 * @param {object} props.children content of component cen be string, number, or node (eg. <span>foobar</span>)
 * @param {object} props.className customize style of component
 * @param {string} props.title content of component with title format
 * @param {string} props.subtitle content of component with subtitle format
 */
const InformationBoxHeader = ({
  children,
  className,
  title,
  subtitle,
  ...rest
}) => {
  const classesRoot = clsx('pml-info-box-header', className.root)
  const classesTitle = clsx(
    'pml-info-box-header__title',
    Typo.subtitle2,
    className.title,
  )
  const classesSubtitle = clsx(
    'pml-info-box-header__subtitle',
    className.subtitle,
  )

  return (
    <div className={classesRoot} {...rest}>
      <style jsx>{styles}</style>
      {title && <div className={classesTitle}>{title}</div>}
      {subtitle && <div className={classesSubtitle}>{subtitle}</div>}
      {children}
    </div>
  )
}

InformationBoxHeader.defaultProps = {
  children: undefined,
  className: {},
  title: undefined,
  subtitle: undefined,
}

InformationBoxHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.shape({
    root: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }),
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

export default InformationBoxHeader
